<script>
    import {Listeners} from "../../../constants/listeners";

    export default {
        data() {
            return {
            }
        },
        props: {
            item:{
                type: Object,
                required: true

            }
        },
        methods: {
            submitFormFilter(){
                this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
            }
        },
    }
</script>
<template>
    <input type="number" class="valueinput" v-model.number="item.value" v-on:keyup.enter="submitFormFilter" />
</template>

